import { API_BASE_URL } from 'utils/constants';
import { notificationsConfigs } from '@thewebops/notifications';
import { firebaseConfig } from 'utils/pushNotifications';

const notificationConfigs = {
  baseURL: `${API_BASE_URL}/users`,
  enableThunks: true,
  enableMapSelectors: true,
  authHeaders: 'authHeaders',
  // The Nutivate-owned Firebase project, per environment (src/firebaseConfigs.json). Without it, no push.
  firebaseConfig,
};

notificationsConfigs.initialize(notificationConfigs);
